import { IValue } from "./ivalue";
import { ControlType } from "../controltype";
import { cloneDeep } from 'lodash-es';
import { EventEmitter } from "@angular/core";

export class HelpValue implements IValue {

    valueField: string;
    value: any[];
    textValue: string;
    clear$ = new EventEmitter();

    static getPropValue(helpItem: any, args: Array<string>): any {
        if (args.length > 1) {
            const arg = args.shift();
            return helpItem[arg] ? this.getPropValue(helpItem[arg], args) : null;
        }
        return helpItem[args[0]];
    }

    clearValue(): void {
        this.value = [];
        this.valueField = undefined;
        this.textValue = undefined;

        this.clear$.emit();
    }
    setOriginalValue(value: any): void {
        throw new Error('Method not implemented.');
    }
    getOriginalValue(): string {
        const args = this.valueField.split('.');
        const valueArr = this.value.map(helpItem => HelpValue.getPropValue(helpItem, cloneDeep(args)));
        return valueArr && valueArr.length ? valueArr.join(',') : '';
    }
    getControlType(): ControlType {
        return ControlType.Help;
    }


    constructor(data: {
        value: any,
        valueField: string,
        textValue: string;
    } = { value: [], valueField: undefined, textValue: undefined }) {
        if (data.hasOwnProperty('textValue')) {// 新结构，value是数组
            this.valueField = data.valueField;
            this.value = data.value;
            this.textValue = data.textValue;
        } else {// 旧结构，value是对象
            this.valueField = data.valueField;
            this.value = data.value ? [data.value] : [];
            this.textValue = 'help-text-value-null'; // 旧结构无textValue属性
        }

    }
    isEmpty(): boolean {
        return !this.valueField;
    }

    getTextValue(textField: string): string {
        const args = textField.split('.');
        const textArr = this.value.map(helpItem => HelpValue.getPropValue(helpItem, cloneDeep(args)));
        return textArr && textArr.length ? textArr.join(',') : '';
    }

}
